import React from "react";

const ListBlock = ({config}) => {
    const items = Array.isArray(config?.items)
        ? config.items
        : [];

    if (items.length === 0) {
        return null;
    }

    const ordered = config?.ordered === true;

    const ListTag = ordered ? "ol" : "ul";

    return (
        <ListTag
            className={
                ordered
                    ? "list-decimal list-inside space-y-2 text-gray-800"
                    : "list-disc list-inside space-y-2 text-gray-800"
            }
        >
            {items.map((item, index) => (
                <li key={index} className="leading-7">
                    {item}
                </li>
            ))}
        </ListTag>
    );
};

export default ListBlock;